const DRAG_SELECTOR = '.drag-scroll';
const DRAG_THRESHOLD_PIXELS = 5;
const MOMENTUM_FRICTION = 0.95;
const MOMENTUM_MIN_SPEED = 0.5;

function enableDragScroll(scroller) {
    let isPressed = false;
    let didDrag = false;
    let startX = 0;
    let startScrollLeft = 0;
    let lastX = 0;
    let speed = 0;
    let momentumFrame = 0;

    function glide() {
        scroller.scrollLeft += speed;
        speed *= MOMENTUM_FRICTION;

        if (Math.abs(speed) > MOMENTUM_MIN_SPEED) {
            momentumFrame = window.requestAnimationFrame(glide);
        }
    }

    scroller.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch' || event.button !== 0) {
            return;
        }

        window.cancelAnimationFrame(momentumFrame);
        isPressed = true;
        didDrag = false;
        startX = event.clientX;
        lastX = event.clientX;
        startScrollLeft = scroller.scrollLeft;
        speed = 0;
        scroller.style.cursor = 'grabbing';
    });

    scroller.addEventListener('pointermove', (event) => {
        if (!isPressed) {
            return;
        }

        const distance = event.clientX - startX;

        // Capture only once dragging so plain clicks still reach links inside.
        if (!didDrag && Math.abs(distance) > DRAG_THRESHOLD_PIXELS) {
            didDrag = true;
            scroller.setPointerCapture(event.pointerId);
        }

        scroller.scrollLeft = startScrollLeft - distance;
        speed = lastX - event.clientX;
        lastX = event.clientX;
    });

    function release() {
        if (!isPressed) {
            return;
        }

        isPressed = false;
        scroller.style.cursor = '';
        momentumFrame = window.requestAnimationFrame(glide);
    }

    scroller.addEventListener('pointerup', release);
    scroller.addEventListener('pointercancel', release);

    scroller.addEventListener('click', (event) => {
        if (didDrag) {
            event.preventDefault();
            event.stopPropagation();
            didDrag = false;
        }
    }, true);

    scroller.addEventListener('dragstart', (event) => event.preventDefault());
}

document.querySelectorAll(DRAG_SELECTOR).forEach(enableDragScroll);
